import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { PaginatedResult } from "../../sessions/contracts/PaginatedResult";
import { HeldTrainingRecordResponse } from "../contracts/HeldTrainingRecordResponse";
import { HeldTrainingRecordPage } from "../models/HeldTrainingRecord";
import { mapResponseToHeldTrainingRecordPage } from "../mappers/HeldTrainingRecordMapper";

/** The organization's training records kept under legal hold (PD-0021); Owner/Admin only. */
export const fetchHeldTrainingRecords = createAsyncThunk<
  HeldTrainingRecordPage,
  { page: number; pageSize: number },
  { rejectValue: ApiErrorResponse }
>("training/fetchHeldRecords", async ({ page, pageSize }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<PaginatedResult<HeldTrainingRecordResponse>>(
      "/training/held-records",
      { params: { page, pageSize } }
    );
    return mapResponseToHeldTrainingRecordPage(response.data);
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load the kept training records"));
  }
});
